export default class ResetGame {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default() {
        this.gb.emitters.emit.web.closeGame();
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            default:
                event["resetGame"] = this._default;
        }

        return event;
    }
}
